import script from "./CompteurPersonnes.vue?vue&type=script&setup=true&lang=js"
export * from "./CompteurPersonnes.vue?vue&type=script&setup=true&lang=js"

import "./CompteurPersonnes.vue?vue&type=style&index=0&id=574f76c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-574f76c6"]])

export default __exports__